import React from 'react';
import { Card, Empty, Row, Col, Statistic } from 'antd';
import { ClockCircleOutlined, ThunderboltOutlined, BarChartOutlined, DatabaseOutlined } from '@ant-design/icons';
import Chart from 'react-apexcharts';

const PeakHoursChart = ({ servidor, height = 300 }) => {
  if (!servidor?.horas?.length) {
    return <Card title={servidor?.nombre || 'Sin datos'}><Empty description="No hay datos de horas pico disponibles" /></Card>;
  }

  const labels = servidor.horas.map(h => h.hora_formato || `${String(h.hora).padStart(2, '0')}:00`);
  const valores = servidor.horas.map(h => parseFloat(h.carga_promedio) || 0);
  const peakIdx = valores.indexOf(Math.max(...valores));

  const getBarColor = (v) => {
    if (v < 1.0) return '#10b981';
    if (v < 2.0) return '#f59e0b';
    return '#f43f5e';
  };

  return (
    <Card
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>{servidor.nombre}{servidor.ip && <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>({servidor.ip})</span>}</span>
          {servidor.hora_pico_formato && (
            <span style={{ fontSize: 12, fontWeight: 'normal', color: '#f43f5e' }}>
              <ClockCircleOutlined /> Hora pico: {servidor.hora_pico_formato}
            </span>
          )}
        </div>
      }
      style={{ marginBottom: 16 }}
    >
      <Chart
        type="bar"
        height={height}
        options={{
          chart: { toolbar: { show: false } },
          plotOptions: {
            bar: {
              borderRadius: 4,
              distributed: true,
              columnWidth: '70%',
            }
          },
          colors: valores.map((v, i) => i === peakIdx ? '#7c3aed' : getBarColor(v)),
          xaxis: { categories: labels, labels: { rotate: -45, style: { fontSize: '11px' } } },
          yaxis: { min: 0, title: { text: 'Carga Promedio' } },
          grid: { borderColor: '#e9edf4', strokeDashArray: 3 },
          tooltip: {
            custom: ({ dataPointIndex }) => {
              const h = servidor.horas[dataPointIndex];
              return `<div style="padding:8px 12px;font-size:13px">
                <strong>${h.hora_formato || labels[dataPointIndex]}</strong><br/>
                Promedio: ${parseFloat(h.carga_promedio).toFixed(2)}<br/>
                Max: ${parseFloat(h.carga_max).toFixed(2)}<br/>
                Min: ${parseFloat(h.carga_min).toFixed(2)}<br/>
                Registros: ${h.count}
              </div>`;
            }
          },
          dataLabels: { enabled: false },
          legend: { show: false },
        }}
        series={[{ name: 'Carga', data: valores }]}
      />

      <Row gutter={16} style={{ marginTop: 16 }}>
        <Col xs={12} sm={6}>
          <Statistic
            title="Hora Pico"
            value={servidor.hora_pico_formato || '--'}
            prefix={<ThunderboltOutlined style={{ color: '#f43f5e' }} />}
            valueStyle={{ fontSize: 16 }}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic
            title="Carga Pico"
            value={parseFloat(servidor.carga_pico || 0).toFixed(2)}
            prefix={<BarChartOutlined style={{ color: '#f59e0b' }} />}
            valueStyle={{ fontSize: 16, color: parseFloat(servidor.carga_pico) >= 2 ? '#f43f5e' : '#333' }}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic
            title="Promedio General"
            value={parseFloat(servidor.carga_promedio_general || 0).toFixed(2)}
            prefix={<BarChartOutlined style={{ color: '#845adf' }} />}
            valueStyle={{ fontSize: 16 }}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic
            title="Total Registros"
            value={servidor.total_registros || 0}
            prefix={<DatabaseOutlined style={{ color: '#10b981' }} />}
            valueStyle={{ fontSize: 16 }}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default PeakHoursChart;
